import { combineReducers } from 'redux';

import {
  GET_PETITIONS_REQUEST,
  GET_PETITIONS_SUCCESS,
  GET_PETITIONS_FAILURE,
  SEND_DECISION_REQUEST,
  SEND_DECISION_SUCCESS,
  SEND_DECISION_FAILURE,
  UPDATE_CATEGORIES_REQUEST,
  UPDATE_CATEGORIES_SUCCESS,
  UPDATE_CATEGORIES_FAILURE,
} from './actionTypes';

const initialState = {
  loading: false,
  error: '',
  petitionsList: [],
  currentPetition: null,
  categoriesOnLoading: false,
};

const reducer = (state = initialState, {
  type, petitionsList, error, petitionId, activeSignatureIndex,
}) => {
  switch (type) {
    case GET_PETITIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PETITIONS_SUCCESS:
      return {
        ...state,
        petitionsList,
        corouselIndex: 0,
        currentPetition: petitionsList && petitionsList[0],
        loading: false,
      };
    case GET_PETITIONS_FAILURE:
      return {
        ...state,
        error,
        loading: false,
      };
    case UPDATE_CATEGORIES_REQUEST:
      return {
        ...state,
        categoriesOnLoading: true,
      };
    case UPDATE_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoriesOnLoading: false,
      };
    case UPDATE_CATEGORIES_FAILURE:
      return {
        ...state,
        categoriesOnLoading: false,
      };
    case SEND_DECISION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEND_DECISION_SUCCESS:
      return {
        ...state,
        petitionsList: state.petitionsList.filter((p) => p.id !== petitionId),
        currentPetition: activeSignatureIndex + 1
         >= state.currentPetition.signatures_for_review
          ? state.petitionsList.filter((p) => p.id !== petitionId)[0] : state.currentPetition,
        loading: false,
      };
    case SEND_DECISION_FAILURE:
      return {
        ...state,
        error,
        loading: false,
      };
    default:
      return state;
  }
};

const petitionReviewRootReducer = combineReducers({
  main: reducer,
});

export default petitionReviewRootReducer;
